import { render, staticRenderFns } from "./DevModeInfo.vue?vue&type=template&id=24b06f6a&scoped=true"
import script from "./DevModeInfo.vue?vue&type=script&lang=js"
export * from "./DevModeInfo.vue?vue&type=script&lang=js"
import style0 from "./DevModeInfo.vue?vue&type=style&index=0&id=24b06f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b06f6a",
  null
  
)

export default component.exports